module.exports = __webpack_public_path__ + "img/bixiu04.95349a38.png";